const TicketDetailPage = () => (
  <div className="p-4">
    <h1 className="text-xl font-bold">Ticket Details</h1>
  </div>
)

export default TicketDetailPage
